// extracted by mini-css-extract-plugin
export default {"boundsTable":"styles_boundsTable__bb+VX","title":"styles_title__-7W6a","listHeader":"styles_listHeader__X8Ip4","listRow":"styles_listRow__Lu4XT","body":"styles_body__voC9K"};